<template>
  <v-container
    grid-list-md
    fluid
    class="pa-0"
  >
    <v-layout
      row
      wrap
      justify-space-around
    >
      <v-flex xs4>
        <v-card
          class="pa-1 max-shadow"
        >
          <v-card-title class="title-2">
            Profile
          </v-card-title>
          <v-divider />
          <v-subheader>Admin</v-subheader>
          <v-list
            dense
            class="pa-3"
          >
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>person</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ vendor.admin.name }}
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>phone</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ vendor.admin.phone }}
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>email</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ vendor.admin.email }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <div>
            <v-subheader>Join Date</v-subheader>
            <div class="body-2 font-weight-regular px-4">
              {{ formatDate(vendor.joinDate) }}
            </div>
          </div>
          <div>
            <v-subheader>Address</v-subheader>
            <div class="body-2 font-weight-regular px-4">
              {{ vendor.address }}
            </div>
          </div>
        </v-card>
      </v-flex>

      <v-flex
        pa-1
        xs8
        height="100vh - 158px"
      >
        <div>
          <v-card>
            <v-layout
              row
              wrap
            >
              <v-card-title class="title-2">
                Revenue
              </v-card-title>
              <v-spacer />
              <v-btn
                color="primary"
                flat
                @click.stop="advanceExportDialog = true"
              >
                Revenue Report
              </v-btn>
            </v-layout>
            <v-divider />
            <v-dialog
              v-model="advanceExportDialog"
              max-width="690"
            >
              <v-card class="max-shadow">
                <v-card-title class="headline">
                  Revenue Report
                </v-card-title>
                <v-card-text>
                  <v-layout
                    row
                    wrap
                    justify-space-around
                  >
                    <v-layout
                      row
                      wrap
                      align-center
                      justify-center
                    >
                      <span>Start Date :</span>
                      <DatePicker
                        v-model="AEStartDate"
                        :max="AEEndDate"
                        :prev-next-btns="false"
                        type="date"
                      />
                    </v-layout>
                    <v-layout
                      row
                      wrap
                      align-center
                      justify-center
                    >
                      <span>End Date :</span>
                      <DatePicker
                        v-model="AEEndDate"
                        :max="AEEndDate"
                        :prev-next-btns="false"
                        type="date"
                      />
                    </v-layout>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    flat
                    @click.native="advanceExportDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    flat
                    @click.native="advanceExport"
                  >
                    Export
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-container
              grid-list-xs
              class="py-2 px-0"
              fluid
            >
              <v-layout
                row
                wrap
                justify-center
              >
                <v-flex
                  xs12
                  lg5
                >
                  <count-widget
                    color="primary "
                    icon="mdi-food-fork-drink"
                    title="Orders"
                    sub-title="Today"
                    :value="ordersToday.length"
                    style="max-width: 300px; margin: 0 auto"
                  />
                </v-flex>
                <v-flex
                  xs12
                  lg5
                >
                  <count-widget
                    color="warning darken-1"
                    icon="mdi-food-fork-drink"
                    title="Orders"
                    sub-title="This month"
                    :value="orders.length"
                    style="max-width: 300px; margin: 0 auto"
                  />
                </v-flex>
                <v-flex
                  xs12
                  lg5
                >
                  <count-widget
                    color="purple darken-3"
                    icon="mdi-currency-inr"
                    title="Revenue"
                    sub-title="Today"
                    :value="getRevenue(ordersToday)"
                    value-prefix="₹"
                    style="max-width: 300px; margin: 0 auto"
                  />
                </v-flex>
                <v-flex
                  xs12
                  lg5
                >
                  <count-widget
                    color="accent darken-1 "
                    icon="mdi-currency-inr"
                    title="Revenue"
                    sub-title="This month"
                    :value="getRevenue(orders)"
                    value-prefix="₹"
                    style="max-width: 300px; margin: 0 auto"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { firestore } from '@/firebase';
import TicketCountwidget from '@/components/common/TicketCountWidget';
import moment from 'moment';
import _toArray from '@/mixins/util-mixin';
import DatePicker from '@/components/common/DatePicker';
import Papa from 'papaparse';

export default {
  name: 'Restaurant',
  components: {
    DatePicker,
    'count-widget': TicketCountwidget
  },
  mixins: [_toArray],
  props: {
    vendorId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      vendor: {
        admin: {}
      },
      orders: [],
      AEStartDate: '',
      AEEndDate: '',
      advanceExportDialog: false
    };
  },
  computed: {
    ordersToday() {
      const today = moment().startOf('day');
      return this.orders.filter(order =>
        moment(order.orderedAt.toDate()).isSameOrAfter(today)
      );
    }
  },
  watch: {
    vendorId: {
      handler(val) {
        const startDate = moment()
          .startOf('month')
          .toDate();
        const endDate = moment()
          .endOf('month')
          .toDate();
        if (!val) return;
        firestore
          .collection('fnb')
          .orderBy('orderedAt', 'desc')
          .where('orderedAt', '>=', startDate)
          .where('orderedAt', '<=', endDate)
          .where('vendorId', '==', val)
          .get()
          .then(fnb => {
            const docs = [];
            fnb.forEach(docSnapshot => {
              docs.push({ ...docSnapshot.data(), ...{ id: docSnapshot.id } });
            });
            // console.log(docs);
            const orders = [];
            docs.forEach(order => {
              let total = 0;
              const items = this._toArray(order.items);
              items.forEach(item => {
                let itemTotal;
                const { price } = item.item;
                const { gst } = item.item;
                const { quantity } = item;
                itemTotal = price * quantity * (gst / 100) + price * quantity;
                total = total + itemTotal;
              });
              orders.push({ ...order, ...{ total: Math.round(total) } });
            });
            this.orders = orders;
            // console.log(orders);
          });
      },
      immediate: true
    }
  },
  mounted() {
    // fetch tenant details
    firestore
      .collection('vendors')
      .doc(this.vendorId)
      .get()
      .then(vendorSnapshot => {
        this.vendor = vendorSnapshot.data();
      });
  },
  methods: {
    formatDate(date) {
      if (date) return moment(date.toDate()).format('DD MMM YYYY');
    },
    getRevenue(orders) {
      if (orders.length === 0) return 0;
      return orders.reduce((a, b) => ({
        total: a.total + b.total
      })).total;
    },
    exportVisitorLog(visitorLog) {
      const keys = [
        'name',
        'email',
        'phone',
        'vendorName',
        'item',
        'quantity',
        'price',
        'status',
        'paymentStatus',
        'orderedAt'
      ];
      const headers = [
        'Name',
        'Email',
        'Phone',
        'Vendor Name',
        'Item',
        'Quantity',
        'Price',
        'Status',
        'Payment Status',
        'Order Date'
      ];
      // const staticKeysLen = 9;
      let rows = [];
      visitorLog.forEach(log => {
        var row = [];
        keys.forEach((key, i) => {
          if (key === 'orderedAt') {
            if (log[key]) {
              row[i] = moment(log[key].toDate()).format('DD-MM-YYYY h:mm A');
            } else {
              row[i] = '';
            }
          } else {
            row[i] = log[keys[i]];
          }
        });
        if (log.orderedBy) {
          row[0] = log.orderedBy.name;
          row[1] = log.orderedBy.email;
          row[2] = log.orderedBy.phone;
        }
        if (log.items) {
          Object.keys(log.items).forEach(itemId => {
            row[4] = log.items[itemId].item.name;
            row[5] = log.items[itemId].quantity;
            row[6] = log.items[itemId].item.price;
            rows.push(row);
            row = [];
          });
        } else {
          rows.push(row);
        }
      });

      if (rows.length === 0) rows = undefined;
      const config = {
        quotes: true,
        quoteChar: '"',
        delimiter: ',',
        header: true,
        newline: '\r\n'
      };
      const csvData = {
        fields: headers,
        data: rows
      };
      const csv = Papa.unparse(csvData, config);

      const blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8;'
      });

      const filename = `Order_log_${moment(this.selectedDate).format(
        'DD_MM_YYYY'
      )}.csv`;
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';

          link.click();
        }
      }
    },
    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },
    advanceExport() {
      const startAt = moment(this.AEStartDate, this.dateFormat)
        .startOf('day')
        .utc()
        .toDate();
      const endAt = moment(this.AEEndDate, this.dateFormat)
        .endOf('day')
        .utc()
        .toDate();
      firestore
        .collection('fnb')
        .orderBy('orderedAt', 'desc')
        .where('orderedAt', '>=', startAt)
        .where('orderedAt', '<=', endAt)
        .where('vendorId', '==', this.vendorId)
        .get()
        .then(snapshot => {
          const AEvisitorLog = snapshot.docs.map(doc => {
            const val = doc.data();
            val.id = doc.id;
            return val;
          });

          if (AEvisitorLog.length !== 0) {
            this.exportVisitorLog(AEvisitorLog);
            this.advanceExportDialog = false;
          } else {
            this.snackbarMessage =
              'No Logs found to export on the selected dates';
            this.snackbar = true;
            this.advanceExportDialog = false;
          }
        });
    }
  }
};
</script>